import { render, staticRenderFns } from "./ProofreadingReviseManuscriptPage.vue?vue&type=template&id=108693ac&scoped=true"
import script from "./ProofreadingReviseManuscriptPage.vue?vue&type=script&lang=ts"
export * from "./ProofreadingReviseManuscriptPage.vue?vue&type=script&lang=ts"
import style0 from "./ProofreadingReviseManuscriptPage.vue?vue&type=style&index=0&id=108693ac&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "108693ac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('108693ac')) {
      api.createRecord('108693ac', component.options)
    } else {
      api.reload('108693ac', component.options)
    }
    module.hot.accept("./ProofreadingReviseManuscriptPage.vue?vue&type=template&id=108693ac&scoped=true", function () {
      api.rerender('108693ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/novel/ProofreadingReviseManuscriptPage.vue"
export default component.exports